<style lang="scss">
  @import '../resources/scss/project_formation.scss';
</style>

<script lang="ts">
  import type ProjectFormationSection from '../api/rest/directus-cms/projects/model/ProjectFormationSection'
  import { Darkness } from '../config/colors'
  export let formationSection: ProjectFormationSection
  export let color_class: string
  const title =
    formationSection.translations[0].title ?? formationSection.translations[0].title
  const description =
    formationSection.translations[0].description ??
    formationSection.translations[0].description
</script>

<div class="container-fluid">
  <div class="container-xxl flex-grow-1">
    <div class="row details">
      <div class="col-12 text-break">
        <h1 class="text-primary-{color_class}">{title}</h1>
        <div class="row">
          <div class="col-12 formation-details">{@html description}</div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid px-0">
  <div
    class="project-image"
    style="background-image: url('{formationSection.section_image?.fullUrl}}');"
  />
</div>
